export default __webpack_public_path__ + "static/media/avatar-news_club_bot.bc766100.png";